export class SectionRequisites {
  static ONE_TO_ONE = 'one_to_one';
  static ONE_TO_MANY = 'one_to_many';
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/types/requisite_enum.ts